<template>
  <v-container>
    <div class="pa-3 display-1">
      事業所の切り替え
    </div>
    <v-row
      align="center"
      justify="center"
      dense
    >
      <v-col cols="10" md="10" dense>
        <v-card v-if= "!isAdmin" flat outlined class="ma-5 pa-3">
          <div class="subtitle-2 mb-2">
            <v-icon class="mr-1" color="primary" small>mdi-information-outline</v-icon>
            <span class="primary--text">事業所の切り替えについて機能について</span>
          </div>
          <p class="caption">
              事業所の切り替え機能は、管理者権限をお持ちの方のみご利用いただけます。<br>
              この機能をご利用になりたい場合は、事業所の管理者様にご連絡してください。<br>
          </p>
        </v-card>

        <v-card v-else class="py-10 px-10">
          <v-card flat outlined class="pa-3">
            <div class="subtitle-2 mb-2">
              <v-icon class="mr-1" color="primary" small>mdi-information-outline</v-icon>
              <span class="primary--text">事業所の切り替えについて</span>
            </div>
            <p class="caption">
              OilMatrixの利用対象の事業所を変更します。<br>
              ご自身の所属事業所以外の事業所のマイ機器の管理などのOilMatrixのサービスがご利用いただけます。<br>
              所属事業所以外の事業所への変更には、各事業所の管理者の許可が必要です。<br>
              他事業所の分析・診断業務を行う必要がある場合は、事業所の管理者様にご連絡ください。<br>
            </p>
          </v-card>

          <v-card flat  class="mb-3">
            <v-divider></v-divider>
            <v-row dense class="pa-2">
              <v-col cols="12" dense>
                <div class="subtitle-2 mb-2">自分の事業所に戻す</div>
              </v-col>
              <v-col cols="8" dense>
              <!-- v-col cols="8" class="teal darken-1 pa-2 mb-1 white--text" -->
                  {{myofficename}}
              </v-col>
              <v-col cols="4" class="text-right" dense>
                <v-tooltip top color="grey darken-2">
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" rounded color="amber darken-1" @click="changeMyOffice()" data-createApplication class="px-2"><v-icon class="mr-2">mdi-checkbox-marked-circle</v-icon>自分の事業所に戻す</v-btn> 
                  </template>
                  <span>クリックすると自身の事業所設定を初期の設定に戻します</span>
                </v-tooltip>
              </v-col>
            </v-row>

            <v-divider></v-divider>
            <v-row dense class="pa-2" v-if="isSystemAdmin">
              <v-col cols="12" >
                <div class="subtitle-2 mb-2">他の企業に切り替える</div>
              </v-col>
              <v-col cols="2" xl="3" lg="3" md="3" sm="5" dense v-if="isSystemAdmin">
                <v-text-field
                  v-model="searchCompanyID"
                  label="企業（得意先）コード"
                  clearable
                  @input="searchCompanyIDinputed"
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="2" xl="2" lg="2" md="3" sm="4" dense>
                <v-btn rounded color="amber darken-1" @click="searchCompany()" class="px-2"><v-icon class="mr-2">mdi-checkbox-marked-circle</v-icon>企業を検索</v-btn> 
              </v-col>
              <v-col cols="12">
                <v-autocomplete 
                  v-model="selectCompany"
                  label="切り替える企業を選択"
                  dense
                  :items="companyList"
                  item-value="CompanyID"
                  item-text="Name"
                  filled
                  @change="changeCompany"
                >
                  <template slot='selection' slot-scope='data'>
                    {{ data.item.CompanyID }} {{ data.item.Name }}
                  </template>
                  <template slot="item" slot-scope="data">
                    <!-- HTML that describe how select should render items when the select is open -->
                    {{ data.item.CompanyID }} {{ data.item.Name }}
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>

            <v-divider></v-divider>
            <v-row dense class="pa-2">
              <v-col cols="12" >
                <div class="subtitle-2 mb-2">他の事業所に切り替える</div>
              </v-col>
              <v-col cols="12">
                <v-select
                  v-model="selectOffice"
                  label="切り替える事業所を選択"
                  dense
                  :items="officeList"
                  item-value="OfficeID"
                  item-text="Name"
                  filled
                >
                  <template slot='selection' slot-scope='data'>
                    {{ data.item.CompanyName }} {{ data.item.Name }}
                  </template>
                  <template slot="item" slot-scope="data">
                    <!-- HTML that describe how select should render items when the select is open -->
                    {{ data.item.CompanyName }} {{ data.item.Name }}
                  </template>
                </v-select>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="12" class="text-right">
              <v-tooltip top color="grey darken-2">
                <template v-slot:activator="{ on }">
                 <v-btn v-on="on" rounded color="amber darken-1" @click="changeOffice()" data-createApplication class="px-2"><v-icon class="mr-2">mdi-checkbox-marked-circle</v-icon>事業所を切り替える</v-btn> 
                </template>
                <span>クリックすると指定した事業所に設定変更します</span>
              </v-tooltip>
              </v-col>
            </v-row>

          </v-card>
        </v-card>
        <!-- <br>{{message}} -->
      </v-col>
    </v-row>

    <suc-dialog :successText="successText" :successUrl="successUrl" ref="isSuccessed"></suc-dialog>


    </v-container>
</template>

<script>

import { API, graphqlOperation} from "aws-amplify"
import { officeByKey, } from '../graphql/queries'
import { sortedCompanylistAnActive, } from '../graphql/queries'
import { companyByKey, } from '../graphql/queries'

/*
import { standardValueByOffice, } from '../graphql/queries'
*/
import Successed from "../components/successDialog.vue"
import initcore  from '../utils/initialize.js'

export default {

name: "ChangeOffice",
  mixins:[initcore],
  head: {
    title: { inner: '事業所の切り替え'},
  },
  components: {
    sucDialog: Successed
  },  
  data() {
    return {
      myofficename: "",
      selectOffice: "",
      selectCompany:"",
      successUrl: '/',
      successText: '事業所を切り替えました。<br>マイページに戻ります。',
      isSuccessed: false,
      companyList: [],
      officeList: [],
      searchCompanyID: "",
    };
  },
  computed: {
    isAdmin () {
      return this.$store.state.isAdmin
    },
    isSystemAdmin : function() {
      return this.$store.state.isSystemAdmin
    }
  },
  mounted: async function () {
    this.myofficename =  this.$store.state.mycompany.Name + " " + this.$store.state.myoffice.Name
    this.selectOffice = this.$store.state.operatingOffice.OfficeID
    this.selectCompany = this.$store.state.operatingOffice.CompanyID

    this.officeList = await this.fetchAllOfficeByCompany(this.selectCompany)
    for (const office of this.officeList) {
      office["CompanyName"] = this.$store.state.mycompany.Name
      office["PaymentOfficeID"] = this.$store.state.mycompany.PaymentOfficeID
    }

    // システム管理者の場合、企業を選択可能
    if (this.$store.state.isSystemAdmin) {
      let companys = await API.graphql(graphqlOperation(sortedCompanylistAnActive, {isActive: "1", limit: 999}))
      this.companyList = companys.data.sortedCompanylistAnActive.items

      let nexttoken = companys.data.sortedCompanylistAnActive.nextToken
      while(nexttoken) {
        let companys2 = await API.graphql(graphqlOperation(sortedCompanylistAnActive, {isActive: "1", limit: 999, nextToken: nexttoken}))
        this.companyList = this.companyList.concat(companys2.data.sortedCompanylistAnActive.items)
        nexttoken = companys2.data.sortedCompanylistAnActive.nextToken
      }

    }

  },
  methods: {
    searchCompanyIDinputed: async function() {
      if(this.searchCompanyID == null) {
        console.log("searchCompanyID cleard")
        this.selectOffice = this.$store.state.operatingOffice.OfficeID
        this.selectCompany = this.$store.state.operatingOffice.CompanyID

        let companys = await API.graphql(graphqlOperation(sortedCompanylistAnActive, {isActive: "1", limit: 999}))
        this.companyList = companys.data.sortedCompanylistAnActive.items
        let nexttoken = companys.data.sortedCompanylistAnActive.nextToken
        while(nexttoken) {
          let companys2 = await API.graphql(graphqlOperation(sortedCompanylistAnActive, {isActive: "1", limit: 999, nextToken: nexttoken}))
          this.companyList = this.companyList.concat(companys2.data.sortedCompanylistAnActive.items)
          nexttoken = companys2.data.sortedCompanylistAnActive.nextToken
        }

        this.officeList = await this.fetchAllOfficeByCompany(this.selectCompany)
        for (const office of this.officeList) {
          office["CompanyName"] = this.$store.state.mycompany.Name
          office["PaymentOfficeID"] = this.$store.state.mycompany.PaymentOfficeID
        }
      }
    },
    searchCompany: async function() {
      if(this.searchCompanyID) {
        this.searchCompanyID = ('0000000000' + this.searchCompanyID).slice(-10)
        let company = await API.graphql(graphqlOperation(companyByKey, {CompanyID: this.searchCompanyID}))
        if(company.data.companyByKey.items[0]) {
          this.selectCompany = this.searchCompanyID
          this.companyList = []
          this.companyList.push(company.data.companyByKey.items[0])

          this.officeList = await this.fetchAllOfficeByCompany(this.searchCompanyID)
          for (const office of this.officeList) {
            office["CompanyName"] = company.data.companyByKey.items[0].Name
            office["PaymentOfficeID"] = company.data.companyByKey.items[0].PaymentOfficeID
          }
          this.selectOffice = this.officeList[0].OfficeID
        }
      }
    },
    changeCompany: async function () {
        let company = await API.graphql(graphqlOperation(companyByKey, {CompanyID: this.selectCompany}))
        this.officeList = await this.fetchAllOfficeByCompany(this.selectCompany)

        // 企業名、事業所名の変更は担当者（Employee）連携時に反映されない
        // 各マスタの名称で上書きする
        for (const office of this.officeList) {
          office["CompanyName"] = company.data.companyByKey.items[0].Name
          office["PaymentOfficeID"] = company.data.companyByKey.items[0].PaymentOfficeID
        }
        this.selectOffice = this.officeList[0].OfficeID
    },
    changeOffice: async function () {
        if(this.selectCompany != this.$store.state.operatingOffice.CompanyID) {
          let company = await API.graphql(graphqlOperation(companyByKey, {CompanyID: this.selectCompany}))
          let operatingcompany = company.data.companyByKey.items[0]
          this.$store.commit('setOperatingCompany',operatingcompany )
        }

        let office = await API.graphql(graphqlOperation(officeByKey, {OfficeID: this.selectOffice}))
        let operatingOffice = office.data.officeByKey.items[0]
        operatingOffice["CompanyName"] = this.$store.state.operatingCompany.Name
        operatingOffice["PaymentOfficeID"] = this.$store.state.operatingCompany.PaymentOfficeID
        this.$store.commit('setOperatingOffice',operatingOffice )

        this.$store.commit('setInitializedAnalize', false )
        this.initAnalizeInfoCore()

        this.isSuccessed = true 
        this.successText = '事業所を切り替えました。<br><br>' + this.$store.state.operatingOffice.CompanyName + " " + this.$store.state.operatingOffice.Name + '<br><br>マイページに戻ります。',
        this.$refs.isSuccessed.open();
    },

    changeMyOffice: async function () {
        this.$store.commit('setOperatingCompany',this.$store.state.mycompany )
        this.$store.commit('setOperatingOffice',this.$store.state.myoffice )
        this.$store.commit('setInitializedAnalize', false )
        this.initAnalizeInfoCore()

        this.isSuccessed = true 
        this.successText = 'ご自身の事業所を戻します。<br><br>' + this.$store.state.operatingOffice.CompanyName + " " + this.$store.state.operatingOffice.Name + '<br><br>マイページに戻ります。',
        this.$refs.isSuccessed.open();
    },

  }
};
</script>
